// components/auth/signing-in-overlay.tsx
// Live feedback, 2026-10-02: "after pressing sign in, or after giving the
// OTP, or after the SSO sign in... put a loading [screen], dim overlay,
// cover the whole screen... logo on top... so there is no way to click
// other button" -- a full screen, pointer-blocking cover for the gap
// between "credentials accepted" and the hard navigation that follows
// (employee-id-login.tsx's window.location.href, or Microsoft's own
// redirect chain), so nothing on the page underneath is clickable while
// that's in flight. On error the caller hides this and shows its own
// inline feedback instead -- this only ever represents "still working,
// outcome not known yet".
import Image from "next/image";
import { AiOutlineLoading } from "react-icons/ai";

export default function SigningInOverlay({ visible, label }: { visible: boolean; label: string }) {
  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm"
    >
      <Image
        src="/alwasail-logo.png"
        height={50}
        width={270}
        className="w-auto"
        style={{ maxWidth: "220px" }}
        alt="Alwasail"
        priority
      />
      <AiOutlineLoading className="h-6 w-6 animate-spin text-primary" aria-hidden="true" />
      <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</p>
    </div>
  );
}
